var React = require('react');
var labels = require('MemberJoinLabels');
var moment = require('moment');
var memberTypeChecker = require('../../../../../Scripts/React/MemberTypeChecker.jsx').step4;
var { $datePicker, $radioButtons } = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationComponents.jsx');
var apiDataConstants = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/apiDataConstants.js');
var validationFunctions = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationFunctions.jsx');

class BoardCredentials extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeSubboardsLoaded: false
        };

        this.handleBoardSubSpecialtyChange = this.handleBoardSubSpecialtyChange.bind(this);
        this.isMatchingSubboard = this.isMatchingSubboard.bind(this);
        this.getSubboardOptionsMarkup = this.getSubboardOptionsMarkup.bind(this);
        this.handleSubSpecialtySelectionChange = this.handleSubSpecialtySelectionChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getSubboardCertificationDateMarkup = this.getSubboardCertificationDateMarkup.bind(this);
    }

    componentDidMount() {
        this.props.loadApiData('activeSubboards');
    }

    handleInputChange(event) {
        this.props.stepState.boardSubSpecialties.filter((sub) => {
            if (sub.Subcode && sub.Subcode === event.target.id) {
                sub["BeginDate"] = event.target.value;
            }
        });
    }

    handleBoardSubSpecialtyChange(event) {
        const value = event.target.value === 'true';
        this.props.updateStepState(event.target.name, value);
    }

    isMatchingSubboard(first, second) {
        return (first.Subcode && (first.Subcode === second.Subcode || first.Subcode === second.SubDemographic)) ||
        (first.SubDemographic &&
            (first.SubDemographic === second.SubDemographic || first.SubDemographic === second.Subcode));
    }

    handleSubSpecialtySelectionChange(event, specialty) {
        var selectedBoard = this.props.stepState.boardSubSpecialties.filter((sub) => {
            return this.isMatchingSubboard(sub, specialty);
        });

        var selectedBoardToDelete = this.props.stepState.boardSubSpecialtiesToDelete.filter((sub) => {
            return this.isMatchingSubboard(sub, specialty);
        });

        // This works around an issue with the API where the same field values have different field names on api endpoints
        var toSave = selectedBoard && selectedBoard.length ? selectedBoard[0] : specialty;
        var toDelete = selectedBoardToDelete && selectedBoardToDelete.length ? selectedBoardToDelete[0] : specialty;

        this.props.updateStepStateMultiSelect(event.target.name, toSave, event.target.checked);
        this.props.updateStepStateMultiSelect('boardSubSpecialtiesToDelete', toDelete, !event.target.checked);
    }

    getSubboardCertificationDateMarkup(checked, option) {
        if (checked) {
            return <div className={"field-wrap"}>
                       <span>{labels.step4.subboardCertDate}</span>
                       <$datePicker id={option.Subcode} value={option.BeginDate ? moment.utc(option.BeginDate).format('YYYY-MM-DD') : ""}
                           onInput={this.handleInputChange} name="subboardCertifiedDate" type="date" date-format="mm/dd/yyyy"
                           validations={[validationFunctions.required, validationFunctions.date]} />
                   </div>;
        }
    }

    getSubboardOptionsMarkup() {
        if (this.props.stepState.hasBoardSubSpecialty && this.props.appState.apiData.activeSubboards && this.props.appState.apiData.activeSubboards.length) {

            var subboardOptions = this.props.appState.apiData.activeSubboards.filter((subboard) => {
                return subboard.Subcode.indexOf(this.props.stepState.boardCertification) === 0 && subboard.Subcode !== apiDataConstants.boardCertificationCodes.aba && subboard.Subcode !== apiDataConstants.boardCertificationCodes.aoba;
            });

            var options = subboardOptions.map((option, index) => {

                var checked = this.props.stepState.boardSubSpecialties.filter((activeBoard) => {
                    var matched = this.isMatchingSubboard(activeBoard, option);
                    if (matched) {
                        option.CusDemographicId = activeBoard.CusDemographicId ? activeBoard.CusDemographicId : 0;
                        option.BeginDate = activeBoard.BeginDate ? activeBoard.BeginDate : "";
                    }

                    return matched;
                }).length;
                
                const subboardDate = this.getSubboardCertificationDateMarkup(checked, option);

                return <div className={"board-credentials"} key={index}>
                    <input type="checkbox"
                        id={option.Subcode}
                        name="boardSubSpecialties"
                        checked={checked}
                        onChange={(event) => this.handleSubSpecialtySelectionChange(event, option)}
                        value={option} />
                    <label className={"memberjoin"} htmlFor={option.Subcode}>{option.Description}</label>
                    {subboardDate}
                </div>;
            });

            return <div>
                {options}
            </div>;
        }
    }

    render() {
        if (memberTypeChecker.hideBoardCredentials(this.props.appState.appType) || (this.props.stepState.boardCertification !== "ABA" && this.props.stepState.boardCertification !== "AOBA")) {
            return null;
        }

        return <div className={"board-credentials-container"}>

            <div className={"row"}>
                <div className={"panel"}>
                    <div className={"col-md-12"}>
                        <h3>{labels.step4.boardCredentials}</h3>
                    </div>
                    <div className={"edit"}>
                        <div className={"col-md-6"}>
                            <div className={"field-group-wrap"}>
                                <label>{labels.step4.areYouSubBoarded}</label>
                                <$radioButtons name="hasBoardSubSpecialty" compareValue={this.props.stepState.hasBoardSubSpecialty} value={this.props.stepState.hasBoardSubSpecialty} selectoptions="yesNo" uselabels={true} onChange={this.handleBoardSubSpecialtyChange} />
                            </div>
                            {this.getSubboardOptionsMarkup()}
                        </div>
                    </div>
                </div>
            </div>

        </div>;
    }
}

module.exports = BoardCredentials;